/* eslint-disable @typescript-eslint/no-misused-promises */
import React, { useContext } from 'react'
import View from '../../atoms/View'
import Text from '../../atoms/TextNew'
import { t } from 'i18next'
import { formatPrice } from 'src/helpers/formatPrice'
import Button from '../../atoms/Button'
import { ItemDispatchContext } from 'src/contexts/itemContext'
import { acceptBuyNowContract } from 'src/helpers/api/acceptBuyNowContract'
import { FETCH_OFFERS, OPEN_DEMO_MODAL } from 'dealer-reducers'
import { useDispatch } from 'react-redux'
import useDealerAllowedToPlaceOffer from 'src/hooks/useDealerAllowedToPlaceOffer'
import track from 'src/helpers/track'

interface Props {
  buyNowPrice: number
  offerId: number
}

const BuyNowBar = ({ buyNowPrice, offerId }: Props): JSX.Element => {
  const dispatch = useDispatch()
  const dispatchItemContext = useContext(ItemDispatchContext)
  const dealerAllowedToPlaceOffer = useDealerAllowedToPlaceOffer()

  if (dispatchItemContext === null) {
    throw new Error('itemContext must be used within a UserProvider')
  }

  return (
    <View
      onClick={(e) => {
        e.stopPropagation()
      }}
      className="h-[104px] px-6 flex justify-between cursor-auto shadow-bothMedium rounded-b-4 bg-gradient-to-b from-blueGradientStart to-blueGradientStop">
      <View className="w-[300px] flex justify-center items-center text-center">
        <Text className="text-xl text-white font-SemiBold">
          <>{t('buy_now_modal.title')}</>
        </Text>
      </View>
      <View className="min-w-[200px] flex justify-center items-center text-center">
        <Text className="text-xxl  text-white font-SemiBold">€ {formatPrice(buyNowPrice)}</Text>
      </View>
      <View className="flex flex-col justify-center gap-2">
        <View className="flex gap-2 justify-around items-center">
          <Button
            color="transparent"
            variant="medium"
            onClick={() => {
              dispatchItemContext({ type: 'TOGGLE_VIEW' })
              dispatchItemContext({ type: 'RESET_BAR' })
            }}>
            <Text className="text-xl text-white font-SemiBold">
              <>{t('auction_contract_modal.resign')}</>
            </Text>
          </Button>
          <Button
            variant="medium"
            disabled={!dealerAllowedToPlaceOffer}
            dataTestId="accept-buy-now-contract-button"
            onClick={async () => {
              try {
                if (!dealerAllowedToPlaceOffer) {
                  dispatch(OPEN_DEMO_MODAL())
                  return
                }
                track('dealer_meaningful_action')
                await acceptBuyNowContract({ offerId })
                dispatchItemContext({ type: 'ACCEPT_BUY_NOW_CONTRACT_SUCCESS' })
                await new Promise((resolve) => {
                  setTimeout(resolve, 1000)
                })
                dispatch(FETCH_OFFERS({ tab: 'in_realization', refetch: true }))
              } catch (error) {
                dispatchItemContext({ type: 'ACCEPT_BUY_NOW_CONTRACT_FAILURE' })
              }
            }}>
            <Text className="text-xl  text-white font-SemiBold">
              <>{t('buy_now_modal.buy_now_button')}</>
            </Text>
          </Button>
        </View>
        <View className="flex gap-1 justify-center max-w-[400px]">
          <Text className="text-white text-m">
            <>{t('buy_now_modal.by_clicking')}</>
          </Text>
          <Text className="text-white text-m font-Bold">
            <>{t('buy_now_modal.buy_now')}</>
          </Text>
          <Text className="text-white">
            <>{t('buy_now_modal.you_realize_sell')}</>
          </Text>
          <Text className="text-white font-Bold">
            <>{t('buy_now_modal.terms')}</>
          </Text>
        </View>
      </View>
    </View>
  )
}

export default BuyNowBar
